module.exports = __webpack_public_path__ + "media/images/coupon/img-franomista-f9e7a6be36bc48b7e3967b7db76bace0.png";